import React, {Component} from 'react'

import CRUDManagerGenerator from '../generators/CRUDGenerator'

const create = {
    table: 'project_contract_statuses',
    mutationType: 'upsert_',
    schema: {
        title: 'Create Project Contract Status',
        type: 'object',
        required: ['description'],
        properties: {
            description: {type: 'string', title: 'Description'}
        }
    }
}

const update = {
    table: 'project_contract_statuses',
    mutationType: 'upsert_',
    schema: {
        title: 'Update Project Contract Status',
        type: 'object',
        required: ['description'],
        properties: {
            id: {type: 'integer'},
            description: {type: 'string', title: 'Description'}
        }
    },
    uiSchema: {
        id: {"ui:widget": "hidden"},
    },
}

const read = {
    title: 'Project Contract Statuses',
    description: '',
    table: 'project_contract_statuses',
    fields: ['id', 'description'],
    uniqueKey: 'id',
    columns: [
        {Header: 'ID', accessor: 'id', maxWidth: '100'},
        {Header: 'Desc', accessor: 'description'}
    ]
}

const config = {
    create,
    read,
    update
}


const CRUDManager = CRUDManagerGenerator(config)

class ProjectContractStatuses extends Component{

    render(){
        return (
            <CRUDManager canCreate canEdit/>
        )
    }
}

export default ProjectContractStatuses